var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PromotionForm',{attrs:{"promotion":_vm.promotion,"buttonLoading":_vm.buttonLoading},on:{"savePromotion":_vm.savePromotion}})
}
var staticRenderFns = []

export { render, staticRenderFns }